

const Footer = () => {

    return (
      <div style={{fontSize: '14px', padding: '8px'}}>Copyright © H2O Hospitality All rights reserved</div>
    )
};

export default Footer;